export const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  name: (lambdaParameter, value) =>
    `${lambdaParameter}.Name.Contains("${value}")`,
  categoryIdWithDescendants: () => null,
  categoriesIds: (lambdaParameter, value) =>
    `new int%3F[] {${(
      value as number[]
    )?.toString()}}.Contains(${lambdaParameter}.CategoryId)`,
  filterRoleId: () => null,
  // deviceType: (lambdaParameter, value, otherValues) => { console.log(value); return 'true'},
  roleId: (lambdaParameter, value, otherValues) =>
    otherValues?.filterRoleId === false
      ? null
      : `${lambdaParameter}.PermittedRoles.Any(pr=>pr.Id.Equals(${value}))`,
  search: (lambdaParameter, value) =>
    `${value
      .toString()
      .split(' ')
      .map(
        (q: string) =>
          `(${lambdaParameter}.Id+" "+${lambdaParameter}.Name).Contains("${q}")`,
      )
      .join('&&')}`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
